const MASK = {
  cover: '',
  mask: ''
}

export default MASK
